import type { StoreApi, UseBoundStore } from 'zustand';
import { createStore, type StoreState } from './Store';
import { AgentState } from '../../server/agent';

const defaults = {
  websocketConnected: false,
  agentState: 'idle' as AgentState,
};

type StatusFields = typeof defaults;
type StatusState = StoreState<StatusFields>;

export const useStatusStore: UseBoundStore<StoreApi<StatusState>> = createStore(defaults);

export type { StatusState };
